module.exports = __webpack_public_path__ + "img/glucose.44973df4.svg";